module.exports = __webpack_public_path__ + "static/media/turin1.928631a8.jpg";